import { defineMessages, IntlShape } from "react-intl";

enum OrgOptions {
  ENTIRE_ORG = "Entire Organization",
  ORG_BY_TEAM = "Entire Organization (by team)",
  ORG_BY_USER = "Entire Organization (by rep)",
  NO_TEAM = "No Team",
}

const messages = defineMessages({
  [OrgOptions.ENTIRE_ORG]: {
    id: "leaderboard.userMenu.entireOrg",
    defaultMessage: "Entire Organization",
    description: "Entire Organization option for userMenu",
  },
  [OrgOptions.NO_TEAM]: {
    id: "leaderboard.userMenu.noTeam",
    defaultMessage: "No Team",
    description:
      "user option for users that aren't part of a team in this organization for userMenu",
  },
  [OrgOptions.ORG_BY_TEAM]: {
    id: "leaderboard.userMenu.orgByTeam",
    defaultMessage: "Entire Organization (by team)",
    description: "Org by team option for userMenu",
  },
  [OrgOptions.ORG_BY_USER]: {
    id: "leaderboard.userMenu.orgByUser",
    defaultMessage: "Entire Organization (by rep)",
    description: "Org by user option for userMenu",
  },
});

export const getOrgOptionsDisplayName = (intl: IntlShape, orgOption: OrgOptions) =>
  intl.formatMessage(messages[orgOption]);

export default OrgOptions;
